import { useEffect } from 'react';
import { FieldErrors } from 'react-hook-form';

import { DataFromFormInputs } from '@/types';

import { TryFormProps, useAnalytics } from './useAnalytics';

const useTryFormErrorsCheck = (
  errors: FieldErrors<DataFromFormInputs>,
  isSubmitting: boolean,
  formName: string,
  formType: TryFormProps['formType'],
) => {
  const { tryFormAnalytics } = useAnalytics();
  useEffect(() => {
    if (Object.keys(errors).length && formType) {
      if (isSubmitting) {
        tryFormAnalytics({
          formType: formType,
          action: 'Поля',
          formName,
          fields: Object.keys(errors),
        });
      }
    }
  }, [errors, formName, formType, isSubmitting, tryFormAnalytics]);
};

export { useTryFormErrorsCheck };
